import { render, staticRenderFns } from "./comment-history.vue?vue&type=template&id=71d6d327&scoped=true&"
import script from "./comment-history.vue?vue&type=script&lang=js&"
export * from "./comment-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d6d327",
  null
  
)

export default component.exports